import { $combine, $combined, $originalMethod } from '@type.engineering/type-engineer'
import { AbstractPainter, setPainterSymbols } from '../../types/lux'
import { isNode } from '../version'
import { setCurrentSeer } from './proxify-state'
import { StatefulCbInstanceSeer } from './Seer'

const paintSet = Symbol('paint set')
const hoardPaints = Symbol('hoard paints')

export default AbstractPainter

class PainterSeer extends StatefulCbInstanceSeer {
  constructor() {
    super()
    this[paintSet] = new WeakSet()
  }
}

/** @constructor @extends {AbstractPainter} @suppress {checkTypes} */ function _Painter() {}
AbstractPainter.__implement(
  _Painter.prototype = /** @type {!AbstractPainter} */ ({
    __$constructor() {
      const seer = new PainterSeer()
      seer.instance = this
      setPainterSymbols(this, {
        _paintSeer: /** @type {!guest.maurice.IStatefulSeer} */ (seer),
      })
      setTimeout(() => {
        this.__$paint()
      }, 1)
    },
    __$paint() {
      if (isNode()) return
      if (this[hoardPaints]) return
      const {asIPainter:{paint,paintSeer}} = this
      let values
      const om = paint[$originalMethod]
      if (om) {
        values = om[$combined]
      } else {
        values = paint[$combined]
      }
      if (values) {
        if (values[0] === Paint) [,...values] = values
        /** @type {!WeakSet} */
        const painterPaintSet = this.paintSeer[paintSet]
        for (const value of values) {
          const hasPaintedBefore = painterPaintSet.has(value)
          if (!hasPaintedBefore) setCurrentSeer(paintSeer, value)
          try {
            value.call(this)
          } finally {
            if (!hasPaintedBefore) {
              painterPaintSet.add(value)
              setCurrentSeer(null)
            }
          }
        }
      } else {
        paint()
      }
      // }, 1)
    },
    paint: Paint,
  }),
)

function Paint() {
  // console.warn('Please provide the paint implementation')
}
Paint[$combine] = true
